import React from 'react';
import {
  SET_IS_VS_POPUP,
  SET_VS_POPUP_CONTENT,
  SET_VS_POPUP_HEIGHT,
  SET_ADD_NOTE_DETAILS,
  SET_VS_POPUP_DETAILS
} from '../actions';

export const isVSPopup = (state = false, action) => {
  switch (action.type) {
    case SET_IS_VS_POPUP:
      return action.payload;
    default:
      return state;
  }
};
export const vsPopupContent = (state = '', action) => {
  switch (action.type) {
    case SET_VS_POPUP_CONTENT:
      return action.payload;
    default:
      return state;
  }
};
export const vsPopupHeight = (state = 0, action) => {
  switch (action.type) {
    case SET_VS_POPUP_HEIGHT:
      return action.payload;
    default:
      return state;
  }
};
export const vsPopupAddNote = (state = {}, action) => {
  switch (action.type) {
    case SET_ADD_NOTE_DETAILS:
      return action.payload;
    default:
      return state;
  }
};

export const vsPopupDetails = (
  state = {
    calledFrom: '',
    calledTo: '',
    calledFromDetails: [],
    calledToDetails: []
  },
  action
) => {
  if (action.type == SET_VS_POPUP_DETAILS) {
    return action.payload;
  }
  return state;
};
